import { TFunction } from 'i18next';

import { IOrderHistory } from '@aqx-core/common/api/order';

export const formatExitMethod = (value: string | number | undefined, _row: IOrderHistory, t: TFunction) => {
  const stringValue = value?.toString();
  if (!stringValue || stringValue === '--') {
    return '--';
  }

  if (stringValue.toLowerCase().includes('expired')) {
    const date = stringValue.split(' ').slice(1).join(' ');
    if (date) {
      return `${t('Expired')} ${date}`;
    }
    return t('Expired');
  }

  if (stringValue.includes('Triggered by Take Profit')) {
    return t('Triggered by Take Profit');
  }

  if (stringValue.includes('Triggered by Stop Loss')) {
    return t('Triggered by Stop Loss');
  }

  return stringValue;
};
